/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Wpm_LabelInputs */

const en_event_warning_wpm_label = /** @type {(inputs: Event_Warning_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WPM`)
};

const fr_event_warning_wpm_label = /** @type {(inputs: Event_Warning_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MPM`)
};

const de_event_warning_wpm_label = /** @type {(inputs: Event_Warning_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WPM`)
};

const it_event_warning_wpm_label = /** @type {(inputs: Event_Warning_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WPM`)
};

const ru_event_warning_wpm_label = /** @type {(inputs: Event_Warning_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`слов в минуту`)
};

const es_event_warning_wpm_label = /** @type {(inputs: Event_Warning_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`palabras por minuto`)
};

const zh_cn2_event_warning_wpm_label = /** @type {(inputs: Event_Warning_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每分钟字数`)
};

const ja_event_warning_wpm_label = /** @type {(inputs: Event_Warning_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1分あたり`)
};

const hi_event_warning_wpm_label = /** @type {(inputs: Event_Warning_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डब्ल्यूपीएम`)
};

const pt_pt2_event_warning_wpm_label = /** @type {(inputs: Event_Warning_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palavras por minuto`)
};

/**
* | output |
* | --- |
* | "WPM" |
*
* @param {Event_Warning_Wpm_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_wpm_label = /** @type {((inputs?: Event_Warning_Wpm_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Wpm_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_warning_wpm_label(inputs)
	if (locale === "de") return de_event_warning_wpm_label(inputs)
	if (locale === "it") return it_event_warning_wpm_label(inputs)
	if (locale === "ru") return ru_event_warning_wpm_label(inputs)
	if (locale === "es") return es_event_warning_wpm_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_warning_wpm_label(inputs)
	if (locale === "ja") return ja_event_warning_wpm_label(inputs)
	if (locale === "hi") return hi_event_warning_wpm_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_warning_wpm_label(inputs)
	return en_event_warning_wpm_label(inputs)
});